

































































































































import { Prop, Component, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import { MyOptions } from "@/charts/graphData";
import { mixins } from "vue-class-component";
import chartsMixin from "./chartsMixin";
import MyMixin from "@/mixins/datemixin";
import jsonURL from "@/shared/urls";
import moment from "moment/moment";
import NumberTmpl from "@/ui-component/number.vue";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class BKData extends mixins(chartsMixin, MyMixin) {
  @Prop() public isTTC!: boolean;
  @Prop() public myOptions!: MyOptions;
  @Prop() public type!: number;
  public dataGetted = false;
  public progression = { lastWeek: 0, lastYear: 0 };
  public value = { today: 0, lastWeek: 0, lastYear: 0 };
  public valueHT = { today: 0, lastWeek: 0, lastYear: 0 };
  public dates: any;
  public config: any;
  public titre = "";
  public typeCorrespondance = {
    0: this.$t("Ca").toString(),
    1: this.$t("ticketMoyen").toString(),
    2: this.$t("nbrTicket").toString(),
  };

  @Watch("myOptions", { immediate: true, deep: true })
  public onOptionsChanged(value: any, oldValue: any) {
    this.init();
  }

  public mounted() {
    this.init();
  }

  public init() {
    this.dates = {
      today: moment(this.myOptions.date).format("DD MMMM yyyy"),
      lastWeek: moment(this.myOptions.date)
        .subtract(7, "day")
        .format("DD MMMM yyyy"),
      lastYear: this.getSameDayLastYear(this.myOptions.date).format(
        "DD MMMM yyyy"
      ),
    };
    this.config = {
      site: this.myOptions.site[0],
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
      dateLastYear: this.getSameDayLastYear(this.myOptions.date).format(
        "YYYY-MM-DD"
      ),
    };
    this.updateWs();
    this.getData();
    this.setDates(this.myOptions.periode);
  }

  public getProgClass(type: "lastWeek" | "lastYear") {
    return this.progression[type] >= 0 ? "over" : "under";
  }
  /**
   * méthode de maj du serveur selon la période et le type de données à afficher
   */
  private updateWs() {
    // if (this.isTTC) {
    switch (this.type) {
      case 0:
        switch (this.myOptions.periode) {
          case "J":
            this.config.WStoday = jsonURL.updateCASurJour;
            this.config.WSlastYear = jsonURL.updateCASurJour;
            this.config.WSlastWeek =
              jsonURL.updateCADynamiqueMemeJourSemainePrecedentePerso;
            this.config.WStodayHT = jsonURL.updateCAHTSurJour;
            this.config.WSlastYearHT = jsonURL.updateCAHTSurJour;
            this.config.WSlastWeekHT =
              jsonURL.updateCAHTDynamiqueMemeJourSemainePrecedentePerso;
            this.config.dateLastYear = this.getSameDayLastYear(
              this.myOptions.date
            ).format("YYYY-MM-DD");
            break;
          case "SEMAINE":
            this.config.WStoday = jsonURL.updateCASurSemaine;
            this.config.WSlastWeek = jsonURL.updateCASurSemaine;
            this.config.WStodayHT = jsonURL.updateCAHTSurSemaine;
            this.config.WSlastWeekHT = jsonURL.updateCAHTSurSemaine;
            this.config.dateLastYear = this.getSameWeekLastYear(
              this.myOptions.date
            ).format("YYYY-MM-DD");
            break;
          case "MOIS":
            this.config.WStoday = jsonURL.updateCASurMoisPerso;
            this.config.WSlastWeek = jsonURL.updateCAMoisPrecedentPerso;
            this.config.WSlastYear =
              jsonURL.updateCAMemeMoisAnneePrecedentePerso;

            this.config.WStodayHT = jsonURL.updateCAHTSurMoisPerso;
            this.config.WSlastWeek = jsonURL.updateCAHTMoisPrecedentPerso;
            this.config.WSlastYear =
              jsonURL.updateCAHTMemeMoisAnneePrecedentePerso;
            this.config.dateLastYear = this.getSameDayLastYear(
              this.myOptions.date
            ).format("YYYY-MM-DD");
            break;
          case "ANNEE":
            this.config.WStoday = jsonURL.updateCASurAnneePerso;
            this.config.WSlastWeek = jsonURL.updateCAAnneePrecedentePerso;
            this.config.WStodayHT = jsonURL.updateCAHTSurAnneePerso;
            this.config.WSlastWeekHT = jsonURL.updateCAHTAnneePrecedentePerso;
            break;
        }
        break;
      case 1:
      case 2:
        switch (this.myOptions.periode) {
          case "J":
            this.config.WStoday = jsonURL.updateCouvEncDynamiqueJour;
            this.config.WSlastYear = jsonURL.updateCouvEncDynamiqueJour;
            this.config.WSlastWeek =
              jsonURL.updateCouvEncDynamiqueMemeJourSemainePrecedentePerso;
            break;
          case "SEMAINE":
            this.config.WStoday = jsonURL.updateCouvEncDynamiqueSemainePerso;
            this.config.WSlastWeek = jsonURL.updateCouvEncDynamiqueSemainePerso;
            break;
          case "MOIS":
            this.config.WStoday = jsonURL.updateCouvEncDynamiqueMoisPerso;
            this.config.WSlastWeek =
              jsonURL.updateCouvEncDynamiqueMoisPrecedentPerso;
            this.config.WSlastYear =
              jsonURL.updateCouvEncDynamiqueMemeMoisAnneePrecedentePerso;
            break;
          case "ANNEE":
            this.config.WStoday = jsonURL.updateCouvEncDynamiqueAnneePerso;
            this.config.WSlastWeek =
              jsonURL.updateCouvEncDynamiqueAnneePrecedentePerso;
            break;
        }
    }
  }
  /**
   * méthode de récupération des données du serveur
   */
  private getData() {
    // console.log(this.type)
    this.$store
      .dispatch("home/getHomeData", {
        config: this.config,
        WS: this.config.WStoday,
      })
      .then((data: any) => {
        switch (this.type) {
          case 0:
            this.value.today = data;
            this.$store
              .dispatch("home/getHomeData", {
                config: this.config,
                WS: this.config.WStodayHT,
              })
              .then((dataht: any) => (this.valueHT.today = dataht));
            break;
          case 1:
            this.value.today = data.moyenne;
            break;
          case 2:
            this.value.today = data.quantite;
            break;
        }
        this.$store
          .dispatch("home/getHomeData", {
            config: this.config,
            WS: this.config.WSlastWeek,
            year: false,
            week: this.myOptions.periode === "SEMAINE" ? true : false,
          })
          .then((data3: any) => {
            // console.log(data3);
            switch (this.type) {
              case 0:
                this.value.lastWeek = data3;
                this.$store
                  .dispatch("home/getHomeData", {
                    config: this.config,
                    WS: this.config.WSlastWeekHT,
                    week: this.myOptions.periode === "SEMAINE" ? true : false,
                  })
                  .then((dataht: any) => (this.valueHT.lastWeek = dataht));
                this.progression.lastWeek = this.calculateProg(
                  this.value.lastWeek,
                  this.value.today
                );
                break;
              case 1:
                this.value.lastWeek = data3.moyenne;
                break;
              case 2:
                this.value.lastWeek = data3.quantite;
                break;
            }
            this.dataGetted = true;
            if (
              this.myOptions.periode !== "SEMAINE" &&
              this.myOptions.periode !== "ANNEE"
            ) {
              this.$store
                .dispatch("home/getHomeData", {
                  config: this.config,
                  WS: this.config.WSlastYear,
                  year: true,
                })
                .then((data2: any) => {
                  switch (this.type) {
                    case 0:
                      this.value.lastYear = data2;
                      this.$store
                        .dispatch("home/getHomeData", {
                          config: this.config,
                          WS: this.config.WSlastYearHT,
                          year: true,
                        })
                        .then(
                          (dataht: any) => (this.valueHT.lastYear = dataht)
                        );
                      this.progression.lastYear = this.calculateProg(
                        this.value.lastYear,
                        this.value.today
                      );
                      break;
                    case 1:
                      this.value.lastYear = data2.moyenne;
                      break;
                    case 2:
                      this.value.lastYear = data2.quantite;
                      break;
                  }
                  this.dataGetted = true;
                });
            }
          });
      });
  }
  /**
   * méthode de calcul des dates en fonction de la période
   * @param periode la période selectionnée
   */
  private setDates(periode: any) {
    switch (periode) {
      case "J":
        this.dates = {
          today: moment(this.myOptions.date).format("DD MMMM yyyy"),
          lastWeek: moment(this.myOptions.date)
            .subtract(7, "day")
            .format("DD MMMM yyyy"),
          lastYear: this.getSameDayLastYear(this.myOptions.date).format(
            "DD MMMM yyyy"
          ),
        };
        break;
      case "SEMAINE":
        this.dates = {
          today:
            this.$t("Sem.").toString() +
            " " +
            moment(this.myOptions.date).format("w YYYY"),
          lastWeek:
            this.$t("Sem.").toString() +
            " " +
            this.getSameWeekLastYear(this.myOptions.date).format("w yyyy"),
          lastYear: "",
        };
        break;
      case "MOIS":
        this.dates = {
          today: moment(this.myOptions.date).format("MMMM yyyy"),
          lastWeek: moment(this.myOptions.date)
            .subtract(1, "month")
            .format("MMMM yyyy"),
          lastYear: "",
        };
        break;
      case "ANNEE":
        this.dates = {
          today: moment(this.myOptions.date).format("yyyy"),
          lastWeek: moment(this.myOptions.date)
            .subtract(1, "year")
            .format("yyyy"),
          lastYear: "",
        };
        break;
    }
  }
  /**
   * methode de calcul de la progression
   * @param ca1 premier CA étudié
   * @param ca2 seconde CA étudié
   */
  private calculateProg(ca1: number, ca2: number) {
    if (ca1 <= 0 && ca2 > 0) {
      return 100;
    } else if (ca1 === 0 && ca2 === 0) {
      return 0;
    } else {
      return ((ca2 - ca1) / ca1) * 100;
    }
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
